import React, { Fragment } from "react";

import { IntentMapperComponent, INTENT_MAPPER_DEFAULT_PROPS } from "../IntentMapperComponent";
import { RadioOption } from "./RadioOption";

import type { RadioIntentToClasses, RadioOptionProps, RadioProps } from "./Radio.d";

export const RADIO_BLANK = {
    className: "",
    descriptionClassName: "",
    descriptionOuterClassName: "",
    labelClassName: "",
};

export const RADIO_PRIMARY = {
    className: "flex items-center cursor-pointer",
    descriptionClassName: "text-0_875 text-gray-65657b tracking-0_2 leading-1_25 pt-4 pl-40",
    descriptionOuterClassName: "flex flex-col",
    labelClassName: "radio-text pl-40 leading-1_25",
};

export class Radio extends IntentMapperComponent<RadioProps> {
    static defaultProps = {
        ...INTENT_MAPPER_DEFAULT_PROPS,
        type: "radio",
    };
    classNameProps = Object.keys(RADIO_PRIMARY);
    intentToClasses: RadioIntentToClasses = {
        blank: RADIO_BLANK,
        primary: RADIO_PRIMARY,
    };

    render() {
        const { defaultChecked = false, options = [], ...rest } = this.getUpdatedProps();
        if (!options.length) {
            return null;
        }
        const customClassNames = this.getUpdatedClassProps();
        const radioOptionProps = {
            ...rest,
            ...customClassNames,
        };
        return (
            <Fragment>
                {options.map(
                    (
                        { checked, description, label, ref, value }: RadioOptionProps,
                        index: number,
                    ) => (
                        <RadioOption
                            {...radioOptionProps}
                            checked={checked}
                            defaultChecked={defaultChecked ? index === 0 : undefined}
                            description={description}
                            key={`${index}:${label}`}
                            label={label}
                            ref={ref}
                            value={value}
                        />
                    ),
                )}
            </Fragment>
        );
    }
}

export default Radio;
